import $ from 'jquery';

// Elements with the ALL selector will automatically have tooltips attached.
const ALL = '[data-toggle="tooltip"]';

// We don't want to publicly expose the Bootstrap implementation of tooltips
// because they use jQuery, and we'd like to avoid jQuery syntax from leaking
// into our app. Our `tooltip` function simply wraps the Bootstrap API and
// hides the fact that it's using jQuery behind the scenes.
//
// For full API reference, see the Bootstrap docs:
// https://getbootstrap.com/docs/4.3/components/tooltips/#usage
const tooltip = (element, options) => $(element).tooltip(options)

// Expose a simple function for selecting all tooltips currently present in the DOM,
// and for binding a MutationObserver that adds tooltips to new elements.
const attachAll = (options) => {
  options = options || {}
  options.boundary = 'window'

  tooltip(ALL, options);

  const observer = new MutationObserver((mutations) => {
    let elements

    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      elements = $(mutation.target).find('[data-toggle="tooltip"]')
      tooltip(elements, options)
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

export default { tooltip, attachAll }
